<div class="review-container" *ngIf="pageJson">
    <h2>Text message <a href="javascript:void(0);" (click)="back('message')">Edit</a></h2>
    <p class="message-text-field">{{pageJson.messageText}}</p>
    <p *ngIf="pageJson.fanSelectionStatus">{{pageJson.fanSelectionStatus}}</p>
    <div *ngIf="pageJson.accordion" class="accordion-grid">
        <p>{{pageJson.subHeading}}</p>
        <app-accordion [accordion]="pageJson.accordion" [accordionController]=false>
            <app-accordion-list *ngFor="let FAN of pageJson.accordion" [option]="FAN" [isSubAccordion]=true>
                <app-customgrid [gridOptions]="pageJson.gridOptions" (onDataChange)="onSelectChange($event)">
                </app-customgrid>
            </app-accordion-list>
        </app-accordion>
    </div>
    <div *ngIf="!pageJson.accordion">
        <h3 *ngIf="selectedList.length>1||selectedList.length==0">{{pageJson.gridHeader.replace("&lt;selected&gt;", selectedList.length)}}</h3>
        <h3 *ngIf="selectedList.length==1">{{pageJson.gridHeader.replace("&lt;selected&gt;", selectedList.length).replace("accounts","account").replace("numbers","number")}}</h3>
        <app-customgrid [gridOptions]="pageJson.gridOptions" (onDataChange)="onSelectChange($event, pageJson.accountType)">
        </app-customgrid>
    </div>
    <div class="cta row">
        <button class="btn btn-secondary col-md-5 col-sm-12 pull-right" id="review-message-btn" (click)="next()" [checkImpersonator]="pageJson.accountType !== 'allCTN' && !selectedList.length" 
            [attr.aria-label]="pageJson.cta.next">{{pageJson.cta.next}}</button>
        <a href="javascript:void(0);" class="btn btn-link btn-block col-sm-12 btn-cancel pull-right text-right" (click)="back('accounts')"><span>{{pageJson.cta.back}}</span></a>
    </div>
</div>
